<script setup lang="ts">
const t2 = useT2({
  'Sign in': 'Prisijungti',
})
const state = useAuthModal()
const auth = useAuth()
const isAuth = shallowRef(auth.value.isAuth)
const timer = useTimeout()

function setAuth(i: boolean, ms: number) {
  timer.set(() => (isAuth.value = i), ms)
}

watch(
  () => auth.value.isAuth,
  (next, prev) => {
    if (helpers.isDef(prev) && prev === false && next === true) {
      state.set(false)
      setAuth(next, 1000)
    } else {
      setAuth(next, 0)
    }
  }
)

const needsAuth = computed(() => state.open.value && !isAuth.value)
// const closed = computed(() => !state.open.value && !auth.value.isAuth)
</script>

<template>
  <Teleport to="#teleports">
    <!-- <button v-if="closed" type="button" :class="[$style.closed, $style.btn]" class="_pl1 _pr2" @click="state.set(true)">
      <IconProfile class="_svg12" />
      {{ t2('Sign in') }}
    </button> -->

    <UiDim2 :open="needsAuth" :click="() => state.set(false)" zindex="199" />

    <div :class="[$style.cont, needsAuth ? 'open' : 'close']">
      <span class="_h4 _row _gap1 _ctrY _gap1 _pt04 _pb1"><IconProfile class="_svg12" />{{ t2('Sign in') }}</span>
      <UiGrow :open="state.open.value">
        <AuthLoginUltimate2 />
      </UiGrow>

      <div class="_row _end _mta _pt8">
        <button type="button" @click="state.set(!state.open.value)" :class="$style.btn" class="_pl1 _pr1">{{ t2('Close') }}<IconExit class="_svg12" /></button>
      </div>
    </div>
  </Teleport>
</template>

<style module>
.cont {
  composes: global(_fixed);
  composes: global(_hcont);
  composes: global(_shadow);
  composes: global(_bg0);
  composes: global(_br22);
  composes: global(_pt1);
  composes: global(_pb1);
  composes: global(_pl1);
  composes: global(_pr1);
  composes: global(_col);
  composes: global(_gap1);
  composes: global(_b5);
  composes: global(_scrollY);

  right: 10px;
  bottom: 10px;

  z-index: 201;
  transition: transform 500ms var(--tran2);

  width: 500px;
  max-width: calc(100% - 20px);
  max-height: 90vh;
}
.cont:global(.open) {
  border: 1px solid var(--blue7);
  box-shadow: 0 0 0 4px var(--blue8);
}
.cont:global(.close) {
  transform: translate3d(0, 110%, 0);
}

.btn {
  composes: global(_br9);
  composes: global(_b5);
  composes: global(_h34);
  composes: global(_spaced);
  composes: global(_gap1);
  composes: global(_flexline);
  composes: global(_ctry);
  composes: global(_fs07);
  composes: global(_fw-xl);
  composes: global(_bg0);

  cursor: pointer;
}
.btn:hover {
  border-color: var(--blue7);
  box-shadow: 0 0 0 4px var(--blue8);
}

.closed {
  composes: global(_shadow);
  composes: global(_fixed);

  right: 10px;
  z-index: 200;
  bottom: 10px;
}
</style>
